import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import { Location } from '@angular/common';
import {UserService} from '../../api/user.service';
import {NotificationServiceBus} from '../../notification/notification.service';
import {GLOBAL} from '../../shared/global';
import {ROLE} from '../../shared/model/role.enum';
import {Accountant, Administrator, BookingOfficer, IndividualClient, Interpreter, OrganisationalRepresentative, User, UserFactory} from '../../shared/model/user.entity';
import {SpinnerService} from '../../spinner/spinner.service';
import { getSubOrgByState } from '../../shared/sub-organisation';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit, OnDestroy {
    public model: any;
    public successMessage = `Congratulations. Your account has been created.
     Please login with your credentials. `;
    public confirmationMessage = 'Thank you for registering with Auslan Connections. ' +
        'We value your business. We will verify your details and be in contact shortly.';
    private sub_param: any;
    public selectedRole = '';
    isEdit = false;
    isDuplicate = false;
    termsAndConditionAccepted = false;
    selectedStatus = '';
    userStatusArray = GLOBAL.userStatusArray;
    userId;
    otherGender = '';
    isRoleInterpreter;
    vicDeaf = ['VIC', 'TAS', 'SA', 'WA'];
    dsq = ['ACT', 'NSW', 'QLD', 'NT'];
    stateBookingOccur = [];
    apiCalled = true;
    isLocked = false;

    constructor(public userService: UserService,
        public notificationServiceBus: NotificationServiceBus,
        public spinnerService: SpinnerService,
        public routes: ActivatedRoute, public router: Router,
        public _location: Location) {
    }
    isUserLogin() {
        return Boolean(GLOBAL.currentUser);
    }

    ngOnInit() {
        this.sub_param = this.routes.queryParams.subscribe(params => {
            let p = this.isRoleInterpreter = params['selectedRole'] || '';
            this.isEdit = Boolean(params['edit_user']);
            this.isDuplicate = Boolean(params['isduplicate']);
            this.selectedRole = Boolean(p && p.length > 1) ? p : this.selectedRole;
            this.userId = params['uid'] || '';
            let jsonData = {};
            if (this.isEdit || this.isDuplicate) {
                this.apiCalled = false;
                this.spinnerService.requestInProcess(true);

                let _id = atob(params['edit_user']);
                this.userService.getUser(+_id)
                    .subscribe((res: any) => {
                        if (res.status === 200) {
                            delete res.data.assignments_attributes;
                            jsonData = res.data;
                            this.filterModel(jsonData);
                            this.apiCalled = true;
                            this.isLocked = this.model.locked;
                        }
                        this.spinnerService.requestInProcess(false);
                    }, err => {
                        console.log(err);
                        let e = err.json();
                        this.notificationServiceBus.launchNotification(true, e);
                        this.spinnerService.requestInProcess(false);
                    });
            }else {
                // jsonData.id = params['uid'] || '';
                this.filterModel(jsonData);
            }
        });
        this.termsAndConditionAccepted = this.isUserLogin();
        if (this.isUserDsqAdmin()) {
            this.stateBookingOccur = this.dsq;
        } else if (this.isUserVicdeaf()) {
            this.stateBookingOccur = this.vicDeaf;
        } else {
            this.stateBookingOccur = this.vicDeaf.concat(this.dsq);
        }
    }
    filterModel(jsonData) {
        switch (this.selectedRole) {
            case 'Administrator'.toUpperCase():
                let admin = this.isEdit ? UserFactory.createUser(jsonData) : new Administrator();
                this.model = admin;
                this.model.role = ROLE.Administrator;
                break;

            case 'BookingOfficer'.toUpperCase():
                let bo = this.isEdit ? UserFactory.createUser(jsonData) : new BookingOfficer();
                this.model = bo;
                this.model.role = ROLE.BookingOfficer;
                break;

            case 'Accountant'.toUpperCase():
                let acc = this.isEdit ? UserFactory.createUser(jsonData) : new Accountant();
                this.model = acc;
                this.model.role = ROLE.Accountant;
                break;


            case 'Interpreter'.toUpperCase():
                let int1: Interpreter = this.isEdit ? <Interpreter>UserFactory.createUser(jsonData) : new Interpreter();
                this.model = int1;
                this.setIfOtherGender();
                this.model.role = ROLE.Interpreter;
                GLOBAL.currentInterpreter = this.isEdit ? int1 : GLOBAL.currentInterpreter;
                localStorage.setItem('userId', this.userId);
                break;

            case 'IndividualClient'.toUpperCase():
                let ic = this.isEdit ? UserFactory.createUser(jsonData) : new IndividualClient(jsonData);
                this.model = ic;
                this.setIfOtherGender();
                this.model.role = ROLE.IndividualClient;
                break;

            case 'OrganisationalRepresentative'.toUpperCase():
            case 'Organisation'.toUpperCase():
                let org = this.isEdit || this.isDuplicate ? UserFactory.createUser(jsonData) : new OrganisationalRepresentative(jsonData);
                this.model = org;
                this.setIfOtherGender();
                this.model.role = ROLE.Organisation;
                if (this.isDuplicate) {
                    this.model.first_name = this.model.last_name =
                        this.model.email = this.model.mobile =
                            this.model.photo_url = this.model.password =
                                this.model.confirm_password = '';
                }
                this.selectedRole = 'ORGANISATION';
                break;
            default:
                this.model = new User();
                this.router.navigate(['/']);
        }
        this.selectedStatus = Boolean(this.model && this.model.disabled === false) ?
            this.userStatusArray[0].name : this.userStatusArray[1].name;
    }

    setIfOtherGender() {
        if (this.model.gender !== 'Male' && this.model.gender !== 'Female' && this.model.gender !== null && this.isEdit) {
            this.otherGender = this.model.gender;
            this.model.gender = 'Other';
        }
    }

    tocChanged(val: boolean) {
        this.termsAndConditionAccepted = val;
    }

    ngOnDestroy() {
        return this.sub_param && this.sub_param.unsubscribe();
    }

    applyChanges(form: any) {
        if (!this.termsAndConditionAccepted) {
            this.notificationServiceBus.launchNotification(true, 'Kindly accept Terms and Conditions');
            return;
        }
        if (form.invalid) {
            this.notificationServiceBus.launchNotification(true, GLOBAL.MISSING_FIELDS_ERROR_MESSAGE);
            this.validateAllFormFields(form.control);
            return;
        }
        this.spinnerService.requestInProcess(true);
        this.isEdit && !this.isDuplicate ? this.editUser() : this.isDuplicate ? this.duplicateUser('create_orgrep') : this.addUser();
    }
    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }
    addUser() {
        this.model.gender = this.model.gender === 'Other' ? this.otherGender : this.model.gender;
        this.userService.createUser(this.model)
            .subscribe((res: any) => {
                if (res.data.id && 0 < res.data.id) {

                    this.model.id = res.data.id;
                    let route = this.isUserLogin ? '/user-management' : '/';
                    this.router.navigate([route]);
                    this.spinnerService.requestInProcess(false);
                    this.successMessage = this.isUserLogin() === false && (this.model instanceof IndividualClient || this.model instanceof OrganisationalRepresentative) ?
                        'Thank you for registering with Auslan Connections.' +
                        ' We value your business. We will verify your details and be in contact shortly.' : this.successMessage;
                    this.notificationServiceBus.launchNotification(false, this.successMessage);
                }
            }, errors => {
                this.spinnerService.requestInProcess(false);
                let e = errors.json();
                this.notificationServiceBus.launchNotification(true, e);
            });
    }

    editUser() {
        this.model.gender = this.model.gender === 'Other' ? this.otherGender : this.model.gender;
        this.model.disabled = this.selectedStatus === 'Disabled';
        this.selectedStatus = '';
        this.userService.updateUser(this.model)
            .subscribe((res: any) => {
                if (res.status === 200) {
                    // UI Notification

                    let route = '/user-management';
                    this.router.navigate([route]);
                    this.spinnerService.requestInProcess(false);
                    this.notificationServiceBus.launchNotification(false, 'User details updated Successfully');
                }
            },
                (err) => {
                    this.spinnerService.requestInProcess(false);
                    let e = err.json();
                    this.notificationServiceBus.launchNotification(true, e);
                });
    }

    duplicateUser(toCreate: string) {
        this.userService.duplicateUser(toCreate, this.model)
            .subscribe((res: any) => {
                if (res.status === 200) {

                    this.model.id = res.data.id;
                    let route = this.isUserLogin() ? '/user-management' : '/';
                    this.router.navigate([route]);
                    this.spinnerService.requestInProcess(false);
                    this.notificationServiceBus.launchNotification(false, this.successMessage);
                }
            }, errors => {
                this.spinnerService.requestInProcess(false);
                let e = errors.json();
                this.notificationServiceBus.launchNotification(true, e);
            });
    }

    checkUserAdminORBookOfficer(): Boolean {
        return Boolean(GLOBAL.currentUser instanceof Administrator ||
            GLOBAL.currentUser instanceof BookingOfficer) ;
    }
    isValidModel(): Boolean {
        return this.apiCalled && Boolean(this.model);
    }
    isUserDsqAdmin(): Boolean {
        return Boolean((GLOBAL.currentUser instanceof Administrator || GLOBAL.currentUser instanceof BookingOfficer)
            && GLOBAL.currentUser.business_name === 'DSQ');
    }

    isUserVicdeaf(): Boolean {
        return Boolean((GLOBAL.currentUser instanceof Administrator || GLOBAL.currentUser instanceof BookingOfficer)
            && GLOBAL.currentUser.business_name === 'Vicdeaf');
    }

    handleFileSelect(evt) {
        let files = evt.target.files;
        let file = files[0];

        if (files && file) {
            let reader = new FileReader();

            reader.onload = this._handleReaderLoaded.bind(this);

            reader.readAsDataURL(file);
        }
    }

    _handleReaderLoaded(readerEvt) {
        this.model.avatar = readerEvt.target.result;
    }

    navigateToPayroll() {
        let val: string = this.selectedRole === 'ORGANISATION' ? this.model.organisation_attributes.id.toString() : this.model.id.toString();
        let navigationExtras: NavigationExtras = {
            queryParams: {userId: val, selectedRole: this.selectedRole}
        };
        this.router.navigate(['/user-management/', 'payroll-billing'], navigationExtras);
    }

    checkIsEditInterpreter() {
        return ((this.isRoleInterpreter === 'INTERPRETER') && this.isEdit);
    }

    goBack() {
      this._location.back();
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/register/register.component.ts